import { css } from "@emotion/core";
import {
  color,
  fontSizes,
  fontTypes,
  fontWeight,
} from "../../constants/commons";

export const showMessageStyle = (loadingState: boolean) => css`
  .custom-modal-container {
    z-index: 5;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    outline: 0;
    background: ${color.blackWithLightOpacity};
  }

  .submitted-message > :first-of-type {
    ${loadingState && `margin: 0 !important;`}
  }
  .custom-modal-data {
    ${loadingState && `padding: 0 !important;`}
  }

  .text-description {
    color: ${color.lightishBlue};
    font-family: ${fontTypes.meduim};
    font-size: ${fontSizes.sm};
    font-weight: ${fontWeight.medium};
    text-align: center;
  }

  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .style-footer-buttons {
      display: flex;
      justify-content: space-evenly;
      font-size: ${fontSizes.xxs};
      .custom-button {
        padding: 1em;
      }
    }
    .custom-modal-content {
      ${loadingState
        ? `padding: 2em 1.25em !important;`
        : `padding: 1.2em 0.6em !important;`}
      border-radius: 2em;
    }
    .custom-modal {
      box-shadow: ${color.customModalBackShadow};
      border-radius: 1.25em;
    }
  }

  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .style-footer-buttons {
      display: flex;
      justify-content: space-evenly;
    }
    .custom-modal-content {
      border-radius: 2em;
      ${loadingState
        ? `padding: 2em 1.25em !important;`
        : `padding: 1.2em !important;`}
    }
    .custom-modal {
      box-shadow: ${color.customModalBackShadow};
      border-radius: 1.25em;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .style-footer-buttons {
      display: flex;
      justify-content: space-evenly;
    }
    .custom-modal-content {
      border-radius: 2em;
      ${loadingState
        ? `padding: 2em 1.25em !important;`
        : `padding: 1.2em !important;`}
    }
    .custom-modal {
      box-shadow: ${color.customModalBackShadow};
      border-radius: 1.25em;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .style-footer-buttons {
      display: flex;
      justify-content: space-evenly;
    }
    .custom-modal-content {
      border-radius: 2em;
      ${loadingState
        ? `padding: 2em 1.25em !important;`
        : `padding: 1.2em !important;`}
    }
    .custom-modal {
      box-shadow: ${color.customModalBackShadow};
      border-radius: 1.25em;
      ${loadingState && ` width: 25% !important; min-width: auto !important`}
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .style-footer-buttons {
      display: flex;
      justify-content: space-evenly;
    }
    .custom-modal-content {
      border-radius: 2em;
      ${loadingState
        ? `padding: 2em 1.25em !important;`
        : `padding: 1.2em !important;`}
    }
    .custom-modal {
      box-shadow: ${color.customModalBackShadow};
      border-radius: 1.25em;
      ${loadingState
        ? ` width: 25% !important; min-width: auto !important`
        : `width: 30% !important; min-width: auto !important`}
    }
  }
`;
